import { createStore } from 'vuex'
import dispatchActionForAllModules from '@/utils/dispatch-action-for-all-modules'
import modules from './modules'
import NProgress from 'nprogress/nprogress'
import axios from 'axios'

export default createStore({
  state: {
    DOMLoaded: false,
    alert: null,
    cancelTokens: {},
    cloudinaryTimestamp: Math.floor(Date.now() / 1000),
    pendingRequests: false,
  },
  getters: {
    DOMLoaded(state) {
      return state.DOMLoaded
    },
    pendingRequests(state) {
      return state.pendingRequests
    },
    appLoading(state) {
      return !state.DOMLoaded || !!state.pendingRequests
    },
    alert(state) {
      return state.alert
    },
    cloudinaryTimestamp(state) {
      return state.cloudinaryTimestamp
    },
  },
  mutations: {
    SET_DOM_LOADED(state) {
      state.DOMLoaded = true
    },
    INCREMENT_PENDING_REQUESTS(state, value) {
      state.pendingRequests += value
    },
    SET_ALERT(state, alert) {
      state.alert = alert
    },
    SET_CANCEL_TOKEN(state, { action, cancelToken }) {
      state.cancelTokens[action] = cancelToken
    },
  },
  actions: {
    incrementPendingRequests({ commit, dispatch }, value) {
      commit('INCREMENT_PENDING_REQUESTS', value)
      dispatch('toggleNProgress')
    },
    setDOMLoaded({ commit }) {
      commit('SET_DOM_LOADED')
    },
    toggleNProgress({ getters }) {
      getters.pendingRequests ? NProgress.start() : NProgress.done()
    },
    setAlert({ commit }, alert) {
      // { title, messages, buttonText, cancelButtonText, buttonAction, classes }
      commit('SET_ALERT', alert)
    },
    resetAlert({ commit }) {
      commit('SET_ALERT', null)
    },
    resetStore({ dispatch }) {
      dispatch('auth/logOut')
    },
    getCancelTokens({ state, commit }, action) {
      const previousRequest = state.cancelTokens[action]

      const source = axios.CancelToken.source()
      commit('SET_CANCEL_TOKEN', { action, cancelToken: source })

      return { previousRequest, cancelToken: source.token }
    },
    // === ActionCable (Notifications) === //
    async onReceived({ commit }, data) {
      const processNotification = data => {
        const { chat, message, type } = data
        if (type === 'ChatNotification') {
          // We also update the chat for the number of unread messages
          commit('chats/UPDATE_CHAT', { chat }, { root: true })
          commit('chats/ADD_MESSAGE', { message }, { root: true })
        }
      }
      if (data.error) {
        throw data
      } else {
        const { notifications } = data
        if (notifications) {
          notifications.forEach(data => processNotification(data))
        } else {
          processNotification(data)
        }
      }
    },
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: import.meta.env.MODE !== 'production',
})

// Automatically run the `init` action for every module,
// if one exists.
dispatchActionForAllModules('init')
